// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1exg5","signatureButtonsRight":"ModalSign_signatureButtonsRight__2bqGV"};